export default `
我睇唔到阿仔IG要搵阿信幫手睇睇。

UPDATE
咁大膽block我！我收你部電話睇你仲點block！
`;
